var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("follow-project-button", {
    attrs: {
      section: "project-timeline",
      "project-id": _vm.projectId,
      "project-name": _vm.projectName,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ onSubscribe }) {
          return [
            _c(
              "button",
              {
                staticClass: "_tc--accent _pa-0 _ttl _tal",
                on: { click: onSubscribe },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.Resources.ProjectHome.ProjectTimelineFollowActionLabel
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }